/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-10-24, 11:29:27
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-03-05, 13:09:33
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

import sRouter from '@/services/sRouter';
import MyNumberCardPrepaidAccountBalance from '@/components/MyAccount/MyNumberCard/MyNumberCardPrepaidAccountBalance';
import MyNumberCardPostpaidAccountBalance from '@/components/MyAccount/MyNumberCard/MyNumberCardPostpaidAccountBalance';

// COMPONENT ///////////////////////////////////////////////////////////////////
export default {
  name: 'MyNumberCard',

  components: {
    MyNumberCardPrepaidAccountBalance, MyNumberCardPostpaidAccountBalance,
  },

  props: {
    subscriber: {
      type: Object,
      default() {
        return {
          account_balance: '0',
          account_balance_current: '0',
          id: null,
          id_tls: '0',
          interest: '0.00',
          number: '000000000',
          type: null,
        };
      },
    },
    acl: Object,
  },

  computed: {
    accountBalanceComponent() {
      const childComponentMap = {
        prepaid: 'MyNumberCardPrepaidAccountBalance',
        postpaid: 'MyNumberCardPostpaidAccountBalance',
      };
      return childComponentMap[this.subscriber.type];
    },
  },

  methods: {
    changeUrl(pathObject) {
      sRouter.changeUrl(pathObject, this.$router);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/MyAccount/MyNumberCard/component.js